/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 抽奖活动
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,
  orderType:
    | "SHOW"
    | "RECHARGE"
    | "COMMODITY"
    | "VIDEO"
    | "ACTIVITYAPPLY"
    | "MOVIE",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.LotteryWinDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/lottery/${orderType}/${orderId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
